import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIcon } from '@angular/material/icon';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { EditorTextChildComponent } from '../../../home/editor-text/editor-text-child/editor-text-child.component';
import { NgStyle } from '@angular/common';
import { DefaultStyleDirective } from '../../../flex-layout/style';


@Component({
  selector: 'calsoft-editor-text',
  imports: [NgStyle, DefaultStyleDirective, DefaultLayoutGapDirective, DefaultLayoutDirective, DefaultLayoutAlignDirective, MatIcon, EditorTextChildComponent],
  templateUrl: './editor-text.component.html',
  styleUrl: './editor-text.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class EditorTextComponent implements OnInit {
  trustedHtmlContent: any;

  @Input() text: any;

  @Input() align: any;

  @Input() data: any;

  @Input() fontSize: any;

  @Input() MobfontSize: any;

  @Input() fontFamily: any;

  @Input() id: any;

  @Input() matIcon: any = 'check_circle';

  arry: any=[];

  icon: boolean | any;



  constructor(
    private sanitizer: DomSanitizer,
   

  ) {
    
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['text']) {
      // console.log('Text changed to:', this.text);
      // // Update trustedHtmlContent whenever text changes
      this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.text);
    }
  }

  ngOnInit() {

    if(this.text.includes('<ul>')){
      this.icon=true;
    }else{
      this.icon=false;
    }

    if(this.text.includes('<li>')){
      this.icon=true;
    }else{
      this.icon=false;
    }



    // console.log(this.text);
    
    
    if (this.icon) {
    //  console.log(this.text);
    this.text = this.text.replace(/<ul>/g, '')
    .replace(/<\/?li>/g, '')
    .replace(/<\/?p>/g, '')
    .replace(/<br>/g, '');



    this.arry = this.text.split('</ul>');
    this.arry = this.arry.filter((item:any) => item.trim() !== '');  

    if(this.arry.length==1){
      this.icon=false;
    }
  }else{

    this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.text);

  }

  // console.log(this.text);
  
  
  }

  checkUlAndLiTags(input: string): boolean {
    const ulLiPattern = /<ul>\s*(<li>.*<\/li>\s*)+<\/ul>/;
    return ulLiPattern.test(input);
  }

}
